import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class SignatarioDocumentoProcessoDigital {
	constructor(URL_PATH) {
		this.URL_PATH = URL_PATH
	}

	async buscarSignatariosDocumento(idDocumento) {
		return await axios.get(`${this.URL_PATH}/processo-digital/documentos/${idDocumento}/signatarios`)
	}

	async convidarSignatariosProcessoDigital(idDocumento, emailsSignatarios) {
		const signatarios = {
			emailsSignatarios,
		}

		return await axios.post(
			`${this.URL_PATH}/documentos/${idDocumento}/processo-digital/convidar-signatario`,
			signatarios,
		)
	}

	async buscarAssinaturasNaoConluidasDocumentoProcessoDigital(id) {
		return await axios.get(`${this.URL_PATH}/${id}/documentos/processo-digital/assinaturas-nao-concluidas`)
	}

	async excluirSignatariosProcessoDigital(idDocumento, emailSignatario) {
		const filters = {
			emailSignatario,
		}

		const url = new SearchUrlParamBuilder({
			urlPath: `${this.URL_PATH}/processo-digital/documentos/${idDocumento}/signatarios`,
			filters,
		}).build()

		await axios.delete(url)
	}
}

export default SignatarioDocumentoProcessoDigital
